<app-view-title Title="Välj släpmodell" [showBack]="true" [isSoftSplit]="true"></app-view-title>
<div class="view-content centered-view  ow-select-obj-backgroundcolor" style="padding: 0;">
  <data-list>
    <app-card web-content (click)="select(423)">
      <img src="/Styles/OneWay/Images/XL.png" />
      <h5>Extra Large</h5>
      <div class="row">
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 350kg<br /> {{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}}: 11m<sup>3</sup></div>
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 366cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 159cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 194cm</div>
      </div>
      <div class="title-with-divider"></div>
      <button mat-raised-button>{{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}</button>
    </app-card>

    <app-card web-content (click)="select(340)">
      <img src="/Styles/OneWay/Images/L.png" />
      <h5>Large</h5>
      <div class="row">
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 430kg<br />{{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}} 9m<sup>3</sup></div>
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 366cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 159cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 155cm</div>
      </div>
      <div class="title-with-divider"></div>
      <button mat-raised-button>{{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}</button>
    </app-card>

    <app-card web-content (click)="select(422)">
      <img src="/Styles/OneWay/Images/M.png" />
      <h5>Medium</h5>
      <div class="row">
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 510kg<br />{{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}} 6,5m<sup>3</sup></div>
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 325cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 152cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 150cm</div>
      </div>
      <div class="title-with-divider"></div>
      <button mat-raised-button>{{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}</button>
    </app-card>

    <app-card web-content (click)="select(421)">
      <img src="/Styles/OneWay/Images/S.png" />
      <h5>Small</h5>
      <div class="row">
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 590kg<br /></div>
        <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 258cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 128cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 140cm</div>
      </div>
      <div class="title-with-divider"></div>
      <button mat-raised-button>{{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}</button>
    </app-card>

    <!-- List Items - Mobile -->
    <list-item mobile-content class="no-border">
      <div class="row" style="display: flex; align-items: center;">
        <div class="title-with-divider">
          <div class="title">Extra Large</div>
        </div>
        <div class="col-4">
          <img style="max-width:100%;" src="/Styles/OneWay/Images/XL.png" />
          <button mat-raised-button
                  (click)="select(423)"
                  style="min-width: unset; height: 45px; max-width: 100px; width:100%; min-height:unset;">
            {{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}
          </button>
        </div>

        <div class="col-8">
          <div class="row" style="display: flex; align-items: center;">
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 350kg<br />{{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}} 11m<sup>3</sup></div>
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 366cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 159cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 194cm</div>
          </div>
        </div>
      </div>
    </list-item>

    <list-item mobile-content class="no-border">
      <div class="row" style="display: flex; align-items: center;">
        <div class="title-with-divider">
          <div class="title">Large</div>
        </div>
        <div class="col-4">
          <img style="max-width:100%;" src="/Styles/OneWay/Images/L.png" />
          <button mat-raised-button
                  (click)="select(340)"
                  style="min-width: unset; height: 45px; max-width: 100px; width:100%; min-height:unset;">
            {{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}
          </button>
        </div>

        <div class="col-8">
          <div class="row" style="display: flex; align-items: center;">
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 430kg<br />{{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}}: 9m<sup>3</sup></div>
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 366cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 159cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 155cm</div>
          </div>
        </div>
      </div>
    </list-item>

    <list-item mobile-content class="no-border">
      <div class="row" style="display: flex; align-items: center;">
        <div class="title-with-divider">
          <div class="title">Medium</div>
        </div>
        <div class="col-4">
          <img style="max-width:100%;" src="/Styles/OneWay/Images/M.png" />
          <button mat-raised-button
                  (click)="select(422)"
                  style="min-width: unset; height: 45px; max-width: 100px; width:100%; min-height:unset;">
            {{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}
          </button>
        </div>

        <div class="col-8">
          <div class="row" style="display: flex; align-items: center;">
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 510kg<br />{{'Intellitrailer.OW.Booking.SelectModel.Volume'| translate : 'Volume'}}: 6,5m<sup>3</sup></div>
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 325cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 152cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 150cm</div>
          </div>
        </div>
      </div>
    </list-item>

    <list-item mobile-content class="no-border">
      <div class="row" style="display: flex; align-items: center;">
        <div class="title-with-divider">
          <div class="title">Small</div>
        </div>
        <div class="col-4">
          <img style="max-width:100%;" src="/Styles/OneWay/Images/S.png" />
          <button mat-raised-button
                  (click)="select(421)"
                  style="min-width: unset; height: 45px; max-width: 100px; width:100%; min-height:unset;">
            {{'Intellitrailer.OW.Booking.SelectModel.Select' | translate : 'Select'}}
          </button>
        </div>

        <div class="col-8">
          <div class="row" style="display: flex; align-items: center;">
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.TotalWeight' | translate : 'Total weight'}}: 1000kg<br />{{'Intellitrailer.OW.Booking.SelectModel.LoadWeight' | translate : 'Load weight'}}: 590kg<br /></div>
            <div class="col-6">{{'Intellitrailer.OW.Booking.SelectModel.Length' | translate : 'Length'}}: 258cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Width' | translate : 'Width'}}: 128cm<br />{{'Intellitrailer.OW.Booking.SelectModel.Height' | translate : 'Height'}}: 140cm</div>
          </div>
        </div>
      </div>
    </list-item>

  </data-list>
</div>
